// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LegacyManufacturer, { LegacyManufacturerStyles } from "@flip/App/Components/Product/LegacyManufacturer";
import { parseBoolean } from "@flip/XDL/Utilities";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

interface OwnProps extends WidgetProps {
    isAuthorized?: boolean;
}

type Props = OwnProps & HasProduct;

export interface ProductDetailsFlipLegacyManufacturerStyles {
    legacyManufacturerStyles?: LegacyManufacturerStyles;
}

export const legacyManufacturerWidgetStyles: ProductDetailsFlipLegacyManufacturerStyles = {};

const styles = legacyManufacturerWidgetStyles;

const ProductDetailsFlipLegacyManufacturer: React.FC<Props> = ({ product, isAuthorized = false }) => {
    if (!product.properties?.legacyManufacturer) {
        return null;
    }

    return (
        <LegacyManufacturer
            legacyManufacturer={product.properties.legacyManufacturer}
            isAuthorized={parseBoolean(product.properties.isLegacyManufacturerAnAuthorizedSupplier)}
            legacyManufacturerLink={product.properties.legacyManufacturerDetailUrl}
            isBrandClickable={true}
            extendedStyles={styles.legacyManufacturerStyles}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsFlipLegacyManufacturer),
    definition: {
        displayName: "Legacy Manufacturer",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
